<template lang="pug">
    .category-post
        component(:is="view")
        Comments(:comments="reversedComments" :pageId="pageId")
</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex'

import BlogPage from '@/views/BlogPage'
import ServicePage from '@/views/ServicePage'
import ContentPage from '@/views/ContentPage'
import CategoryPage from '@/views/CategoryPage'
import Comments from '@/components/Comments'

export default {
    name: 'CategoryPost',
    components: {
        BlogPage,
        ServicePage,
        ContentPage,
        CategoryPage,
        Comments
    },
    computed: {
        reversedComments() {
            let comments = []
            if (this.comments && this.comments.length) {
                comments = _.cloneDeep(this.comments).reverse().filter(comment => !! comment.body)
            }

            return comments
        },
        ...mapGetters({
            view: 'currentPage/view',
            comments: 'currentPage/comments',
            pageId: 'currentPage/id',
        })
    }
}

</script>

<style lang="sass" scoped></style>
